import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/Home.vue')
	},
	{
		path: '/journal',
		name: 'journal',
		component: () => import('@/views/Journal.vue')
	},
	{
		path: '/stock',
		name: 'stock',
		component: () => import('@/views/Stock.vue')
	},
	{
		path: '/sales',
		name: 'sales',
		component: () => import('@/views/Sales.vue')
	},
	{
		path: '/goods',
		name: 'goods',
		component: () => import('@/views/Goods.vue')
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router
